import React from 'react';
import { Alert, Snackbar, Stack } from '@mui/material';
import { style } from './style';

const AUTO_HIDE_TIME = 4000;

type ErrorMessageSnackProps = {
  showError: boolean,
  errorMessage: string,
  onClose?: (e: React.SyntheticEvent | Event, reason?: string) => void,
}
export const ErrorMessageSnackbar = (
  {
    showError: isError,
    errorMessage,
    onClose,
  }:ErrorMessageSnackProps):JSX.Element => {
  return (
    <Stack spacing={ style.stack.spacing } sx={ style.stack.sx }>
      <Snackbar
        anchorOrigin={ style.snackBar.sx }
        open={ isError }
        message={ errorMessage }
        autoHideDuration={ AUTO_HIDE_TIME }
        onClose={ onClose }
      >
        <Alert severity={ style.alert.severity } sx={ style.alert.sx }>
          { errorMessage }
        </Alert>
      </Snackbar>
    </Stack>
  );
};

ErrorMessageSnackbar.defaultProps = {
  onClose: undefined,
};
